var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:" driver-insight-view",attrs:{"align-center":"","justify-center":"","fill-height":""}},[(_vm.enabled && !_vm.loading && !_vm.noData)?_c('v-layout',{staticClass:"pa-0",attrs:{"column":""}},[_c('v-layout',{staticClass:"top-row",attrs:{"align-center":"","justify-center":"","wrap":""}},[_c('v-flex',{attrs:{"md5":"","sm12":""}},[(!_vm.loading)?_c('pie-chart',{staticStyle:{"max-width":"300px","margin":"auto"},attrs:{"data":_vm.pieChartData,"options":{
            centerText: { label: _vm.chartLabel, score: 'Drivers' },
            legend: false,
            responsive: true,
            maintainAspectRatio: true,
            tooltips: {
                callbacks: {
                    label: function(item, data) {
                        var base =
                          data.labels[item.index] + ': <b>' + data.datasets[item.datasetIndex].data[item.index] + '%</b>'

                        if (data.datasets[item.datasetIndex].counts)
                          { base += '(' + data.datasets[item.datasetIndex].counts[item.index] + ')' }
                        return base
                    }
                }
            }
          }}}):_vm._e()],1),_c('v-flex',{staticClass:"pr-3 pl-3",attrs:{"md7":"","sm12":""}},[_c('v-layout',{attrs:{"column":""}},[(_vm.metricQuestions.length > 0)?_c('v-flex',{staticClass:"mb-2 question-area"},[_c('QuestionRenderer',{attrs:{"question":_vm.metricQuestions[1].question,"placeholders":{
                brand_name: _vm.$store.getters['user/currentCampaign'].brand_name
              }}})],1):_vm._e(),_c('v-flex',{staticClass:"table-area"},[_c('SummaryTable',{attrs:{"headers":['Driver', 'Count', 'Percentage'],"rows":_vm.table}})],1)],1)],1)],1),_c('v-layout',{staticClass:"driver-distribution",attrs:{"align-center":"","justify-center":""}},[_c('v-flex',[_c('div',{staticClass:"driver-distribution-header"},[_vm._v("\n          Driver Distribution\n        ")]),(!_vm.loading)?_c('horizontal-bar-chart',{staticStyle:{"max-width":"700px","margin":"auto"},style:({ height: _vm.chartData.labels.length * 50 + 'px' }),attrs:{"data":_vm.chartData,"options":{
            centerText: null,
            legend: false,
            responsive: true,
            maintainAspectRatio: false,
            gridLines: false,
            scales: {
              xAxes: [
                {
                  stacked: true,
                  gridLines: {
                    color: 'rgba(0, 0, 0, 0)'
                  },
                  ticks: {
                    callback: function() {
                      return null
                    }
                  },
                  categoryPercentage: .5,
                  barPercentage: 1.0,
                  display: false,
                  barThicknes: 30,
                }
              ],
              yAxes: [
                {
                  stacked: true,
                  gridLines: {
                    color: 'rgba(0, 0, 0, 0)',
                    display: false
                  },
                  
                  categoryPercentage: .6,
                  barPercentage: 1.0,
                  display: true,
                  ticks: {
                    fontColor: _vm.colors.theme.primaryLight4
                  }
                }
              ]
            }
          }}}):_vm._e()],1)],1)],1):_vm._e(),(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_vm._e(),(!_vm.loading && _vm.noData)?_c('NoResult'):_vm._e(),(!_vm.loading && !_vm.enabled)?_c('div',[_vm._v("Driver question is disabled")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }